module.exports = __webpack_public_path__ + "img/Time-Series.85f254bd.jpg";